module.exports = __webpack_public_path__ + "img/Weapon_204.e02bbc2b.png";